import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogActions } from '@mui/material'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import CloseIcon from '@mui/icons-material/Close'
import { Button, buttonModes, buttonTypes } from '..'
import { Logger, LoggerTypes } from '../../utils'

/**
 * This dialog is used by the to display any editable forms
 * that contains a <form> element.
 * The [save] button submit this form.
 * The form container should listen to the onSubmit event to handle the request.
 * Ex: <DialogFormImport>
 *       <MyForm/>
 *     </DialogFormImport>
 * with :
 *
 * @returns {Dialog}
 **/
export const DialogFormImport = ({ openDialog, setOpenDialog, children, maxWidth, className }) => {
  const { t } = useTranslation()
  const childrenRef = useRef({})

  const onCloseDialog = (e) => {
    e.preventDefault()
    Logger.trace(LoggerTypes.CONTROLLER, 'DialogFormImport.onCloseDialog()', { e })
    setOpenDialog(false)
  }

  const onSubmitForm = (e) => {
    e.preventDefault()
    Logger.trace(LoggerTypes.CONTROLLER, 'DialogFormImport.onSubmitForm()', { e, childrenRef })
    childrenRef.current.onSubmitForm()
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'DialogFormImport.render()', { childrenRef, children })

  return (
    <Dialog
      fullwidth={true}
      maxWidth={maxWidth}
      // onClose={onCloseDialog}  // <-- close while clicking on background
      open={openDialog}
      aria-labelledby="form-dialog-title"
      className={`${className}`}
    >
      <DialogContent>
        {React.cloneElement(children, {
          ref: (ref) => (childrenRef.current = ref)
        })}
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.cancel')}
          icon={<CloseIcon />}
          onClick={onCloseDialog}
        />
        <Button
          mode={buttonModes.PRIMARY_ACTION}
          type={buttonTypes.SUBMIT}
          text={t('common.import')}
          icon={<ImportExportIcon />}
          onClick={onSubmitForm}
        />
      </DialogActions>
    </Dialog>
  )
}

DialogFormImport.displayName = 'DialogFormImport'

DialogFormImport.propTypes = {
  className: PropTypes.string,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  maxWidth: PropTypes.string
}

DialogFormImport.defaultProps = {
  className: '',
  openDialog: false,
  setOpenDialog: () => {},
  children: null,
  maxWidth: 'md'
}
